import { GlobalServiceService } from 'src/app/services/global-service.service';
import { LocalstorageService } from './../services/localstorage.service';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import { catchError, map, tap } from "rxjs/operators";
import { ApiBasic } from "../services/api-basic";
import { Subscription } from 'rxjs';

/*
  Generated class for the LoginProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MaintenanceProvider {
  private token = "";

  private httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      "Authorization": `Bearer ${this.token}`
    })
  }
  appBase: any;
  subscription: Subscription;
  constructor(
    public http: HttpClient,
    public api: ApiBasic,
    public _global: GlobalServiceService,
    private _localstorage: LocalstorageService,
  ) {
    // this._global.base_url = this.api.base_url
    this.token = _global.token
    this.subscription = this._localstorage.getToken().subscribe(message => {
      this.token = _global.token
    });
  }

  public editMaintenanceHojaRuta(maintenanceID, data, user_id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };

    return this.http.patch(
      this._global.base_url +
      "/maintenances/" +
      maintenanceID +
      "/page_route?user_id=" +
      user_id,
      data,
      httpOptions
    );
  }

  public maintenanceHojaRuta(maintenanceID) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };

    return this.http.get(
      this._global.base_url + "/maintenances/" + maintenanceID + "/page_route",
      httpOptions
    );
  }

  public maintenancesAll(data: any, filters: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };

    var queryData = this.api.stringfyObject(data);
    let queryFilter = this.api.stringfyFilter(filters);
    return this.http.get(
      this._global.base_url +
      "/maintenances/all?" +
      queryData +
      "&filters=" +
      queryFilter,
      httpOptions
    );
  }

  public maintenance(data: any, maintenanceID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };

    var queryData = this.api.stringfyObject(data);

    return this.http.get(
      this._global.base_url + "/maintenances/" + maintenanceID + "?" + queryData,
      httpOptions
    );
  }

  public deleteMaintenance(data: any, maintenanceID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    var queryData = this.api.stringfyObject(data);
    return this.http.delete(
      this._global.base_url + "/maintenances/" + maintenanceID + "?" + queryData,
      httpOptions
    );
  }

  public maintenanceNotes(data: any, maintenanceID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    var queryData = this.api.stringfyObject(data);
    return this.http.get(
      this._global.base_url +
      "/maintenances/" +
      maintenanceID +
      "/notes?" +
      queryData,
      httpOptions
    );
  }

  public maintenanceImages(data: any, maintenanceID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    var queryData = this.api.stringfyObject(data);
    return this.http.get(
      this._global.base_url +
      "/maintenances/" +
      maintenanceID +
      "/images?" +
      queryData,
      httpOptions

    );
  }

  public addNote(data: any, maintenanceID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };

    return this.http.post(
      this._global.base_url + "/maintenances/" + maintenanceID + "/notes",
      data,
      httpOptions
    );
  }

  public addImage(data: any, maintenanceID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.post(
      this._global.base_url + "/maintenances/" + maintenanceID + "/images",
      data,
      httpOptions

    );
  }

  public addSketch(data: any, maintenanceID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.post(
      this._global.base_url + "/maintenances/" + maintenanceID + "/sketches",
      data,
      httpOptions

    );
  }

  public addInvoices(data: any, maintenanceID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.post(
      this._global.base_url + "/maintenances/" + maintenanceID + "/invoices",
      data,
      httpOptions

    );
  }

  public getSketch(data: any, maintenanceID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    var queryData = this.api.stringfyObject(data);
    return this.http.get(
      this._global.base_url +
      "/maintenances/" +
      maintenanceID +
      "/sketches?" +
      queryData,
      httpOptions

    );
  }

  public getInvoices(data: any, maintenanceID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };

    var queryData = this.api.stringfyObject(data);
    return this.http.get(
      this._global.base_url +
      "/maintenances/" +
      maintenanceID +
      "/invoices?" +
      queryData,
      httpOptions

    );
  }

  public toProcess(data: any, maintenanceID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.put(
      this._global.base_url + "/maintenances/" + maintenanceID + "/toprocess",
      data,
      httpOptions

    );
  }

  public toClose(data: any, maintenanceID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };

    return this.http.put(
      this._global.base_url + "/maintenances/" + maintenanceID + "/toclose",
      data,
      httpOptions

    );
  }

  public summary(data: any, maintenanceID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    var queryData = this.api.stringfyObject(data);
    return this.http.get(
      this._global.base_url +
      "/maintenances/" +
      maintenanceID +
      "/summaryclose?" +
      queryData,
      httpOptions

    );
  }

  public providers() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.get(this._global.base_url + "/providers",
      httpOptions
    );
  }

  public saveMaintenance(data: any, maintenanceID: number) {
    // return this.http.patch(
    //   this._global.base_url + "/maintenances/" + maintenanceID,
    //   data,
    //   {}
    // );
  }

  public createMaintenance(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.post(this._global.base_url + "/maintenances", data, httpOptions);
  }


  public maintenancePlan(id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.get(
      this._global.base_url + "/maintenances/" + id + "/plan",
      httpOptions
    );
  }


}
